// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "body,\nhtml {\n  margin: 0;\n  overflow-x: hidden;\n  padding: 0;\n  background-color: white;\n}\n", "",{"version":3,"sources":["App.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,uBAAuB;AACzB","file":"App.css","sourcesContent":["body,\nhtml {\n  margin: 0;\n  overflow-x: hidden;\n  padding: 0;\n  background-color: white;\n}\n"]}]);
// Exports
module.exports = exports;
